import { NavLink, useLocation } from "react-router-dom";
import { Wordmark } from "@/components/Wordmark";
import { UserArea } from "@/features/dashboard/components/UserArea";
import { DASHBOARD_NAV } from "@/constants/nav";
import { ROUTES } from "@/constants/routes";

const linkClass = (isActive) =>
  `group relative flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors duration-200 ${
    isActive ? "bg-white/[0.06] text-[#F4F2EC]" : "text-zinc-400 hover:bg-white/[0.03] hover:text-zinc-100"
  }`;

export function Sidebar({ onNavigate, idPrefix = "" }) {
  const { pathname } = useLocation();
  return (
    <div className="flex h-full flex-col bg-ink px-4 py-8">
      <div className="px-3">
        <Wordmark to={ROUTES.dashboard} inverted />
      </div>
      <nav data-testid={`${idPrefix}sidebar-nav`} className="mt-12 flex flex-col gap-1" aria-label="Dashboard">
        {DASHBOARD_NAV.map(({ label, to, icon: Icon, testId, end, alsoActive }) => {
          const extra = Boolean(alsoActive && pathname.startsWith(alsoActive));
          return (
          <NavLink key={to} to={to} end={end} onClick={onNavigate} data-testid={`${idPrefix}${testId}`} aria-current={extra ? "page" : undefined} className={({ isActive }) => linkClass(isActive || extra)}>
            {({ isActive }) => (
              <>
                <span className={`absolute left-0 top-1/2 h-5 w-[2px] -translate-y-1/2 rounded-full bg-gold transition-opacity ${isActive || extra ? "opacity-100" : "opacity-0"}`} />
                <Icon className="h-4 w-4" aria-hidden="true" />
                <span>{label}</span>
              </>
            )}
          </NavLink>
          );
        })}
      </nav>
      <div className="mt-auto">
        <UserArea idPrefix={idPrefix} />
      </div>
    </div>
  );
}
